import { TOKEN } from "./constant";
import { parseUnits, encodePacked, keccak256 } from "viem";
import { MerkleTree } from "merkletreejs";

// Function to generate Merkle tree and claims data
export function generateMerkleTree(airdropList) {
  // Validate input
  if (!Array.isArray(airdropList) || airdropList.length === 0) {
    throw new Error("Airdrop list must be a non-empty array");
  }

  // Step 1: Generate leaf hashes
  const leafHashes = airdropList.map((entry) =>
    keccak256(
      encodePacked(
        ["address", "uint256"],
        [entry.recipient, parseUnits(entry.amount, 18)]
      )
    )
  );

  // Step 2: Build the Merkle tree
  const tree = new MerkleTree(leafHashes, keccak256, { sortPairs: true });
  const root = tree.getHexRoot();

  // Step 3: Generate claims data for each recipient
  const claimsData = airdropList.map((entry) => {
    // Generate the specific leaf hash for the recipient
    const claimerLeafHash = keccak256(
      encodePacked(
        ["address", "uint256"],
        [entry.recipient, parseUnits(entry.amount, 18)]
      )
    );

    // Get the proof for this leaf
    const proof = tree.getHexProof(claimerLeafHash);

    // Return the complete data object
    return {
      receiver: entry.recipient,
      quantity: entry.amount,
      proofs: proof,
      token: TOKEN,
    };
  });

  // Return the Merkle root and claims data
  return {
    merkleRoot: root,
    claimsData: claimsData,
  };
}